/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import { UserContext } from "../../Provider";
import { CalendarIcon } from "../../assets/svg/calendarIcon";
import AGSelect from "../../components/AgSelect";
import { ComMainService, OptionModel, TblComOfferingType } from "../../models";
import { httpDownload, httpGET, httpPOST } from "../../utils/ajaxHelper";
import { API_CONSTANT, OFFERING_TYPE } from "../../utils/constant";
import { compare } from "../../utils/sort";
import { Tab } from "../ExpertiseServiceManagement/style";
import ChangeLogTab from "./ChangeLogTab";
import MessageSentTab from "./MessageSentTab";
import PageViewTab from "./PageViewTab";
import SearchLogTab from "./SearchLogTab";
import CardInfo from "./cardInfo";
import {
  IDashBoardStaffProps,
  IFilterByTime,
  IResultDashboardStaff,
  IResultOverviewCounter,
  ISearchParamDashboardStaff,
  TabDashboardType
} from "./dashboardStaff.props";
import { Container } from "./dashboardStaff.styled";
import { useNotification } from "../../components/Notification";
import { AddIconDatePickerBlack } from "../../components/AddIconDatePicker";

const DashboardStaffPage: React.FC<IDashBoardStaffProps> = ({ ...props }: IDashBoardStaffProps) => {
  const user = useContext(UserContext);

  const filterByTimeOptions: OptionModel[] = user?.userConfiguration.dateRangeOption ?? [];

  const [dataSearchDashboardStaff, setDataSearchDashboardStaff] = useState<IResultDashboardStaff>();

  const TAB_DATA = [
    {
      tabValue: "Search Log",
      tabKey: "TabSearchLog",
      components: (offeringType?: OFFERING_TYPE) => {
        return (
          <SearchLogTab
            data={dataSearchDashboardStaff?.logDatas?.data ?? []}
            maxLength={dataSearchDashboardStaff?.logDatas?.maxLength ?? 0}
            page={searchParam.page}
            pageCount={dataSearchDashboardStaff?.logDatas?.totalPage ?? 0}
            onHandleNextPage={(page) => {
              setSearchParam({
                ...searchParam,
                page,
              });
            }}
            isLoading={isLoadingDataUser}
          />
        );
      },
    },
    {
      tabValue: "Inquiry Log",
      tabKey: "TabMessageSent",
      components: (offeringType?: OFFERING_TYPE) => {
        return (
          <MessageSentTab
            data={dataSearchDashboardStaff?.messageSentDatas?.data ?? []}
            maxLength={dataSearchDashboardStaff?.messageSentDatas?.maxLength ?? 0}
            page={searchParam.page}
            pageCount={dataSearchDashboardStaff?.messageSentDatas?.totalPage ?? 0}
            onHandleNextPage={(page) => {
              setSearchParam({
                ...searchParam,
                page,
              });
            }}
            isLoading={isLoadingDataUser}
            offeringType={offeringType}
          />
        );
      },
    },
    {
      tabValue: "Page Views",
      tabKey: "TabPageViews",
      components: (offeringType?: OFFERING_TYPE) => {
        return (
          <PageViewTab
            data={dataSearchDashboardStaff?.logDatas?.data ?? []}
            maxLength={dataSearchDashboardStaff?.logDatas?.maxLength ?? 0}
            page={searchParam.page}
            pageCount={dataSearchDashboardStaff?.logDatas?.totalPage ?? 0}
            onHandleNextPage={(page) => {
              setSearchParam({
                ...searchParam,
                page,
              });
            }}
            isLoading={isLoadingDataUser}
            offeringType={offeringType}
          />
        );
      },
    },
    {
      tabValue: "Change Log",
      tabKey: "TabChageLog",
      components: (offeringType?: OFFERING_TYPE) => {
        return (
          <ChangeLogTab
            data={dataSearchDashboardStaff?.logDatas?.data ?? []}
            maxLength={dataSearchDashboardStaff?.logDatas?.maxLength ?? 0}
            page={searchParam.page}
            pageCount={dataSearchDashboardStaff?.logDatas?.totalPage ?? 0}
            onHandleNextPage={(page) => {
              setSearchParam({
                ...searchParam,
                page,
              });
            }}
            isLoading={isLoadingDataUser}
            offeringType={offeringType}
          />
        );
      },
    },
  ];

  const [tabSelected, setTabSelected] = useState(TAB_DATA[0]);
  const [filterByTime, setfilterByTime] = useState(filterByTimeOptions[0]);
  const [mainService, setMainService] = useState<ComMainService[]>([]);
  const [selectMainService, setSelectMainService] = useState<any>();
  const [comOfferingTypes, setComOfferingTypes] = useState<OptionModel[]>([])
  const [chooseComOfferingType, setChooseComOfferingType] = useState<OptionModel>()
  const [resultOverviewCounter, setResultOverviewCounter] = useState<IResultOverviewCounter>({
    messageSent: 0,
    numberOfSearch: 0,
    numberOfService: 0,
    pageView: 0,
  });
  const { showNotification } = useNotification();

  const [searchParam, setSearchParam] = useState<ISearchParamDashboardStaff>({
    page: 1,
    tab: tabSelected.tabKey as TabDashboardType,
    interval: filterByTime.value,
    timeZone: new Date().getTimezoneOffset() / (-60),
    currentDateString: moment().format("MM/DD/YYYY").toString(),
    offeringType: chooseComOfferingType?.value ?? OFFERING_TYPE.SERVICE
  });

  const convertOfferingTypeToString = (type?: number) => {
    switch (type) {
      case OFFERING_TYPE.SERVICE:
        return "SERVICE";
      case OFFERING_TYPE.PRODUCT:
        return "PRODUCT";
      case OFFERING_TYPE.SECONDMENT:
        return "SECONDMENT";
      default:
        return null;
    }
  }

  const { mutate: getComMainServices } = useMutation(
    (offeringType?: number) =>
      httpGET({
        url: API_CONSTANT.INBOX_MESSAGE.COMMAIN_SERVICE + "?type=" + convertOfferingTypeToString(offeringType),
      }),
    {
      onSuccess: (rs, offeringType) => {
        if (rs) {
          let rsData = [{
            mainServiceId: 0,
            mainServiceName: "Show all",
          }]

          if (offeringType !== OFFERING_TYPE.ORGANIZATION) {
            rsData.push(...rs.sort(
              (
                a: any,
                b: any,
              ) =>
                compare(
                  a,
                  b,
                  "mainServiceName",
                ),
            ))

            rsData = [...rsData, {
              mainServiceId: -1,
              mainServiceName: "Other",
            }]
          }


          setMainService(rsData);
          if (!selectMainService) {
            setSelectMainService({
              value: rsData[0].mainServiceId,
              label: rsData[0].mainServiceName,
            });
          }
        }
      },
    },
  );

  const { mutate: getDataOverview } = useMutation(
    (interval: number) =>
      httpGET({
        url: API_CONSTANT.DASHBOARD_STAFF.OVERVIEW,
        params: {
          interval,
          timeZone: new Date().getTimezoneOffset() / (-60),
          currentDateString: moment().format("MM/DD/YYYY").toString()
        },
      }),
    {
      onSuccess: (rs) => {
        if (rs) setResultOverviewCounter(rs);
      },
    },
  );

  const { mutate: exportToExcel, isLoading: isExportToExcel } = useMutation(
    (data: any) =>
      httpDownload({
        method: "POST",
        url: API_CONSTANT.DASHBOARD_STAFF.EXPORT_EXCEL,
        data,
      }),
    {
      onSuccess: (rs) => {
      },
      onError: (rs: any) => {
        showNotification(rs.message, "Error");
      }
    },
  );

  const { mutate: searchDataUser, isLoading: isLoadingDataUser } = useMutation(
    () =>
      httpPOST({
        url: API_CONSTANT.DASHBOARD_STAFF.MAIN_URL,
        data: searchParam,
      }),
    {
      onSuccess: (rs) => {
        if (rs) setDataSearchDashboardStaff(rs);
      },
    },
  );

  const { mutate: getComOfferingTypes, } = useMutation(
    () =>
      httpGET({
        url: "/DashboardStaff/comoffering-type",
      }),
    {
      onSuccess: (rs) => {
        const options = (rs as TblComOfferingType[])?.map(e => ({
          label: e.offeringTypeName,
          value: e.offeringTypeId
        })) ?? []

        setComOfferingTypes(options);
        setChooseComOfferingType(options?.find(e => e.value === OFFERING_TYPE.SERVICE) ?? undefined)
      },
    },
  );

  useEffect(() => {
    setDataSearchDashboardStaff(undefined);
    if (searchParam) {
      searchDataUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam]);

  useEffect(() => {
    if (filterByTime) {
      getDataOverview(filterByTime.value ?? 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterByTime]);

  useEffect(() => {
    getComOfferingTypes()
    getComMainServices(OFFERING_TYPE.SERVICE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleExportToExcel = () => {
    const dataExport = {
      ...searchParam,
      timeZone: new Date().getTimezoneOffset() / (-60),
      currentDateString: moment().format("MM/DD/YYYY").toString(),
      interval: filterByTime.value,
    }

    exportToExcel(dataExport)
  }

  return (
    <Container>
      <div className=" mb-[15px] flex border-gray-300 border w-fit text-[0.875rem] text-[#58585B] p-3 bg-white rounded-[10px]">
        <Tab className="active"> Admin Dashboard</Tab>
        <Tab >
          <Link to="/inquiry-management">
            Inquiries Management
          </Link>
        </Tab>
        <Tab>
          <Link to="/admin-firm-management">Organizations Management</Link>
        </Tab>
        <Tab>
          <Link to="/admin-service-management">Offerings Management</Link>
        </Tab>
      </div>

      <section className="">
        <div className="flex flex-row  justify-between items-center w-full mb-[15px] ">
          <div className="w-[245px] h-[34px] ">
            <AddIconDatePickerBlack>
              <AGSelect
              options={filterByTimeOptions}
              value={filterByTime}
              onChange={(option) => {
                if (option) {
                  const optionData = option as IFilterByTime;
                  setfilterByTime(optionData);
                  setSearchParam({
                    ...searchParam,
                    interval: optionData.value,
                    page: 1,
                  });
                }
              }}
              isIconStart = {true}
              />
            </AddIconDatePickerBlack>
          </div>

          <a
            role="button"
            onClick={() => !isExportToExcel && handleExportToExcel()}
            className={`focus:ring focus:ring-blue-300 link-redirect whitespace-nowrap font-bold `}
          >
            Export to Excel
          </a>
        </div>

        <div className=" flex flex-row space-x-[28px] mb-[15px]">
          <CardInfo
            title="Number of Searches"
            value={resultOverviewCounter.numberOfSearch}
          />
          <CardInfo
            title="Inquiries Sent"
            value={resultOverviewCounter.messageSent}
          />
          <CardInfo
            title="Page Views"
            value={resultOverviewCounter.pageView}
          />
          <CardInfo
            title="Number of Offerings"
            value={resultOverviewCounter.numberOfService}
          />
        </div>
      </section>

      <section>

        <div className=" mb-[15px] rounded-[10px] bg-white w-full px-[20px] py-[14px] flex flex-row h-[60px]">
          {TAB_DATA.map((e) => (
            <div
              key={e.tabKey}
              className={`cursor-pointer ${e.tabKey === tabSelected.tabKey ? "bg-[#2c76aa]" : ""
                } rounded-[6px] flex justify-center items-center w-[130px]`}
              onClick={() => {
                setTabSelected(e);
              
                setSelectMainService({
                  value: selectMainService.value ?? mainService[0].mainServiceId,
                  label: selectMainService.label ?? mainService[0].mainServiceName,
                });
                setSearchParam({
                  ...searchParam,
                  tab: e.tabKey as TabDashboardType,
                  mainService: selectMainService?.value ?? 0,
                  page: 1,
                });
              }}
            >
              <p
                className={`${e.tabKey === tabSelected.tabKey ? "text-white" : "text-[#58585B]"
                  } text-[0.875rem] px-[11px] py-[4px] font-medium m-0`}
              >
                {e.tabValue}
              </p>
            </div>
          ))}
        </div>

        <div className=" mb-[15px] flex flex-row space-x-[25px] items-center justify-start">
          <p className="text-[#58585B] font-bold text-[1rem] whitespace-nowrap">Filter by:</p>
          <div className="w-[245px] h-[34px] z-50">
          <AGSelect
            options={comOfferingTypes}
            value={chooseComOfferingType}
            onChange={(option) => {
              if (option) {
                const optionData = option as OptionModel;
                setChooseComOfferingType(option);
                setSelectMainService({
                  value: mainService[0].mainServiceId,
                  label: mainService[0].mainServiceName,
                });
                setSearchParam({
                  ...searchParam,
                  page: 1,
                });
                setSearchParam({
                  ...searchParam,
                  mainService: 0,
                  offeringType: optionData.value ?? OFFERING_TYPE.SERVICE,
                  page: 1,
                });
                getComMainServices(optionData.value);
              }
            }}
          />
        </div>
          <div className="w-[230px] h-[34px] z-50">
            <AGSelect
              options={mainService?.map((item: ComMainService) => ({
                value: item.mainServiceId,
                label: item.mainServiceName,
              }))}
              value={selectMainService}
              onChange={(option: any) => {
                setSelectMainService(option);
                setSearchParam({
                  ...searchParam,
                  mainService: option.value,
                  page: 1,
                });
              }}
            />
          </div>
        </div>

        <div>{TAB_DATA.find((x) => x.tabKey === tabSelected.tabKey)?.components(chooseComOfferingType?.value)}</div>
      </section>
    </Container>
  );
};

export default React.memo(DashboardStaffPage);
